import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/offer';
import { trackPixelEvent } from '../utils/metaPixel';
interface CtaButtonProps {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  fullWidth?: boolean;
  className?: string;
}
export function CtaButton({
  children,
  size = 'md',
  fullWidth = false,
  className = ''
}: CtaButtonProps) {
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={() => trackPixelEvent('InitiateCheckout', {
    content_name: 'The Perfect Dog Method — Complete bundle',
    value: PRICE,
    currency: 'USD'
  })} className={`group inline-flex items-center justify-center gap-3 rounded-full bg-terracotta text-center font-sans font-extrabold uppercase leading-tight tracking-[0.04em] text-white shadow-[0_6px_0_0_#7C2D12] transition-[background-color,transform] duration-150 ease-out hover:bg-terracotta-dark focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-terracotta/25 active:translate-y-1 active:shadow-[0_3px_0_0_#7C2D12] ${size === 'lg' ? 'px-6 py-4 text-[13px] sm:px-12 sm:py-5 sm:text-base' : 'px-5 py-3.5 text-xs sm:px-7 sm:text-sm'} ${fullWidth ? 'w-full' : 'w-full sm:w-auto'} ${className}`} data-id="element-80" data-mp="qjsarhixfb8s">
      <span data-id="element-81" data-mp="3jy8hjoawpubt">{children}</span>
      <ArrowRightIcon className="hidden h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1 sm:block" aria-hidden="true" data-id="element-82" data-mp="3ow0eiwqes6mv" />
    </a>;
}